import { createTheme } from '@mui/material/styles'

export const sizing = {
  header: {
    height: 75
  },
  subHeader: {
    height: 35
  },
  footer: {
    height: 55
  },
  padding: {
    container: 5
  },
  scrollbar: {
    width: 8,
    height: 8
  }
}

export const createAppTheme = (palette) => {
  return createTheme({
    typography: {
      fontFamily: ['Open Sans', 'sans-serif'].join(',')
    },
    palette: {
      mode: palette.textColor === '#ffffff' ? 'dark' : 'light',
      primary: {
        main: palette.headerColor,
        success: palette.successText
      },
      secondary: {
        main: palette.paperColor
      },
      text: {
        primary: palette.textColor,
        secondary: palette.textColorSecondary
      },
      background: {
        default: palette.background,
        paper: palette.paperColor
      },
      error: {
        main: palette.errorText,
        light: palette.errorMain
      },
      warning: {
        main: palette.warningText,
        light: palette.warningMain
      },
      info: {
        main: palette.infoText,
        light: palette.infoMain
      },
      success: {
        main: palette.successText,
        light: palette.successMain
      }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: palette.background,
            scrollbarColor: `${palette.headerColor} ${palette.paperColor}`,
            '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
              backgroundColor: palette.paperColor,
              width: `${sizing.scrollbar.width}px`,
              height: `${sizing.scrollbar.height}px`
            },
            '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
              borderRadius: '2px',
              backgroundColor: palette.headerColor,
              overflow: 'hidden'
            },
            '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
              backgroundColor: palette.headerColor
            },
            '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
              backgroundColor: palette.headerColor
            },
            '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
              backgroundColor: palette.headerColor
            },
            '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
              backgroundColor: palette.paperColor
            }
          }
        }
      },
      MuiIconButton: {
        variants: [
          {
            props: { variant: 'avatar' },
            style: {
              textTransform: 'none',
              marginLeft: 'auto',
              padding: '5px',
              paddingRight: '10px'
            }
          }
        ]
      }
    }
  })
}
